// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"style_linkButton__1GfZl"};